import "client-only";

import { TaskLogsSchema, TasksSchema, type Task, type TaskLog } from "@/contracts/tasks";
import { client } from "@/lib/platform/client";

function taskPath(taskId: string): string {
  return `/api/tasks/${encodeURIComponent(taskId)}`;
}

async function fetchTasks(): Promise<Task[]> {
  return client.get("/api/tasks", { expect: TasksSchema });
}

async function fetchLogs(
  taskId: string,
  dates: { fromDate?: number; toDate?: number } = {},
): Promise<TaskLog[]> {
  const params = new URLSearchParams();
  if (dates.fromDate !== undefined) params.set("fromDate", String(dates.fromDate));
  if (dates.toDate !== undefined) params.set("toDate", String(dates.toDate));
  const query = params.size ? `?${params}` : "";
  return client.get(`${taskPath(taskId)}/logs${query}`, { expect: TaskLogsSchema });
}

async function start(taskId: string): Promise<void> {
  await client.post(`${taskPath(taskId)}/execute`);
}

async function cancel(taskId: string): Promise<void> {
  await client.post(`${taskPath(taskId)}/cancel`);
}

export const tasks = { cancel, fetchLogs, fetchTasks, start };
